// "1:00 PM" → minutes since midnight, so the day's meals list in eating order.
const timeToMinutes = (time) => {
  const match = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec(time || "");
  if (!match) return Number.POSITIVE_INFINITY;
  const hours = (Number(match[1]) % 12) + (match[3].toUpperCase() === "PM" ? 12 : 0);
  return hours * 60 + Number(match[2]);
};

// Today's meals in eating order. Several of the same type (two snacks) all show.
export const getTodayMeals = (meals) => {
  if (!Array.isArray(meals)) return [];
  return meals
    .filter((meal) => meal && typeof meal === "object")
    .map((meal, index) => ({
      id: typeof meal.id === "string" ? meal.id : null,
      key: meal.id || `${meal.meal}-${meal.time}-${index}`,
      meal: meal.meal || "Comida",
      description: meal.description || meal.name || "",
      time: meal.time || "",
      satiety: meal.satiety ?? null,
    }))
    .sort((a, b) => timeToMinutes(a.time) - timeToMinutes(b.time));
};
